import { Notyf } from "notyf";

document.addEventListener("turbo:load", function () {
  let csrfToken = document
    .querySelector("meta[name='csrf-token']")
    .getAttribute("content");
  let notyf = new Notyf({
    position: {x:'right',y:'bottom'},
    duration: 4000
  });
  let slug = window.courseSlug; //set in frontend layout

  let subscribeViaUrl = new URL(window.location.href).searchParams.get("subscribe");

  if (subscribeViaUrl) {
    fetch(`/api/course/${slug}/subscribe`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": csrfToken
        }
      }
    )
    .then(function(res){
      if (res.status === 400) {
        return;
      }
      if (res.status === 401) {
        window.location.href = "/auth";
      }
      if (res.status === 403) {
        return;
      }
      let url = new URL(window.location.href);
      // url.searchParams.set('param1', 'val1');
      url.searchParams.delete('subscribe');
      window.history.replaceState(null, null, url);
      notyf.success({message: "Kurs erfolgreich abonniert!", icon: false});
      window.dataLayer.push({
        'event': 'Workshops subscribed'
      });
      document.querySelectorAll('[data-course-subscription-toggle]').forEach((toggle) => {
        toggle.dataset.subscribed = "true";
      });
      return res.json();
    });
  }

  document.querySelectorAll('[data-course-subscription-toggle]').forEach((toggle) => {
    toggle.querySelector('[data-button-subscribe]').addEventListener("click", function (e) {
      e.preventDefault();

      fetch(`/api/course/${slug}/subscribe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrfToken
          }
        }
      )
      .then(function(res){
        if (res.status === 401) {
          window.location.href = "/auth";
        }
        notyf.success({message: "Kurs erfolgreich abonniert!", icon: false});
        window.dataLayer.push({
          'event': 'Workshops subscribed'
        });
        document.querySelectorAll('[data-course-subscription-toggle]').forEach((toggle) => {
          toggle.dataset.subscribed = "true";
        });
        return res.json();
      });
    });

    toggle.querySelector('[data-button-unsubscribe]').addEventListener("click", function (e) {
      e.preventDefault();

      fetch(`/api/course/${slug}/unsubscribe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": csrfToken
          }
        }
      )
      .then(function(res){
        if (res.status === 401) {
          window.location.href = "/auth";
        }
        notyf.success({message: "Kurs erfolgreich deabonniert!", icon: false});
        window.dataLayer.push({
          'event': 'Workshops unsubscribed'
        });
        document.querySelectorAll('[data-course-subscription-toggle]').forEach((toggle) => {
          toggle.dataset.subscribed = "false";
        });
        return res.json();
      });
    });

  });
});